import { atom } from "recoil";
export const flagState = atom({
    key: "flagState", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
